<template>
  <div
    class="mt-2 flex justify-center p-4 bg-default-bg-light text-default-text-lighter rounded-md border border-indigo-100 border-dashed border-opacity-10"
    @drop.prevent="handleFileDrop"
    @dragover.prevent
  >
    <div class="space-y-1 text-center p-4">
      <div class="text-md">
        <label :for="id">
          Upload a
          <span
            class="underline relative cursor-pointer rounded-md font-medium text-pink-600 hover:text-pink-700 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-cyan-500"
            >Jupyter notebook, Python or markdown file</span
          >
          <input
            :id="id"
            type="file"
            class="sr-only"
            accept=".py,.ipynb,.md"
            @change="handleFileInput"
          />
        </label>
      </div>
      <p v-if="file" class="text-sm text-cyan-100 font-bold">
        Selected file: {{ file.name }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Object,
    default: null,
  },
});

const id = Math.random().toString(36).slice(2);
const emit = defineEmits(["update:modelValue"]);
const file = ref(null);

function setFile(f) {
  // Check that the file is a valid type
  const extension = f.name.split(".").pop();
  if (!["py", "ipynb", "md"].includes(extension)) {
    alert(
      "Invalid file type. Please upload a Jupyter notebook, Python or markdown file."
    );
    return;
  }
  file.value = f;
  emit("update:modelValue", file.value);
}

function handleFileInput(event) {
  setFile(event.target.files[0]);
}

function handleFileDrop(event) {
  const droppedFiles = event.dataTransfer.files;
  if (droppedFiles) {
    setFile(droppedFiles[0]);
  }
}
</script>
